import { pageModule } from '@components/pageModule';
import React from 'react';
import { Route } from 'react-router';
import { AsyncPageRender } from '../../../Components/AsyncComponent';
import { ProtectedRoute } from '../../../Components/Layout/ProtectedRoute';

export const routes$ = {
    List: AsyncPageRender(() => pageModule(import('./List/Admin'))),
};

function Router() {
    return (
        <>
            <Route exact path={'/designs/designers/list'} component={ProtectedRoute(routes$.List)} />
        </>
    );
}

export default Router;
